"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fontFamily = `
    @font-face {
    font-family: 'Europa';
    src: url('/fonts/europa/EuropaRegular.ttf');
    src: url('/fonts/europa/EuropaRegular.otf');
    font-weight: 400;
    font-style: normal;
    }

    html {
        font-family: "Europa", sans-serif;
    }
`;
exports.default = {
    fontFamily,
};
